import lPrompt from '@/components/l-prompt'
let ua = navigator.userAgent.toLowerCase()
const iOS_MINIMUM_VERSION = 10
const Android_MINIMUM_VERSION = 6

export default {
  /**
   * @description 版本具备可访问性
   * @returns {Boolean/Error} {accessible:boolean,message:string}
   */
  isAccessible() {
    // PC 限制 Chrome浏览器 以及最低版本限制
    if (this.isPC()) {
      if (this.isChrome) {
        if (this.chromeVersion()) {
          return {
            accessible: true,
          }
        }
        return {
          accessible: false,
          isChromeVersion: false,
          message:
            '当前浏览器版本过低，影响使用，请升级浏览器版本～;如果您现在使用的是移动设备，请将浏览器设置中的“请求电脑桌面版”关闭后刷新页面',
        }
      } else {
        return {
          accessible: false,
          isChrome: false,
          message: '为了确保良好闯关体验，请您使用Chrome浏览器',
        }
      }
    } else {
      // 百度浏览器、QQ浏览器、UC浏览器、微信内置环境会导致学习过程中断，不建议使用
      if (
        this.isBaiduBroswer() ||
        this.isQQBroswer() ||
        this.isUCBroswer() ||
        this.isWeixin()
      ) {
        return {
          accessible: false,
          message:
            '您当前使用的浏览器会导致闯关过程中断，建议使用系统自带浏览器或Chrome浏览器',
        }
      }
      // HarmonyOS，可用但建议使用自带浏览器
      if (this.isHarmonyOS()) {
        return {
          accessible: true,
          isHarmonyOS: true,
          isHuaWeiBrowser: false,
          message:
            '您当前使用的浏览器会导致闯关过程中断，建议使用系统自带浏览器或Chrome浏览器',
        }
      } else if (this.isIOS()) {
        let iOSVer = this.iOSVersion()

        if (parseInt(iOSVer) < iOS_MINIMUM_VERSION) {
          return {
            accessible: false,
            isIOS: true,
            iOSVersion: iOSVer,
            message: `您当前使用的设备系统版本${iOSVer}较低，建议将系统升级为最新版本后再闯关`,
          }
        }

        return {
          accessible: true,
          isIOS: true,
          isSafari: this.isSafari(),
          isChrome: this.isChrome(),
          iOSVersion: iOSVer,
          message: '建议使用Safari获取Chrome浏览器',
        }
      } else if (this.isAndroid()) {
        let androidVer = this.androidVerison()
        if (parseInt(androidVer) < Android_MINIMUM_VERSION) {
          return {
            accessible: false,
            isAndroid: true,
            iOSVersion: androidVer,
            message: `您当前使用的设备系统版本${androidVer}较低，建议将系统升级为最新版本后再闯关`,
          }
        }

        return {
          accessible: true,
          isAndroid: true,
          androidVerison: androidVer,
          isHuaWeiBrowser: this.isHuaWeiBrowser(),
          message:
            '您当前使用的浏览器会导致闯关过程中断，建议使用系统自带浏览器或Chrome浏览器',
        }
      }
    }
  },
  /**
   * @description
   */
  checkVersion() {
    let checkInfo = this.isAccessible()
    if (!checkInfo.accessible) {
      lPrompt({
        message: checkInfo.message,
        successTxt: '好的',
      })
    }
  },
  /**
   * @description PC
   * @returns Boolean
   */
  isPC: function () {
    let client = ['android', 'iphone', 'phone', 'ipad', 'ipod', 'mobile']
    let ispc = true

    for (let i = 0;i < client.length;i++) {
      if (ua.indexOf(client[i]) > -1) {
        ispc = false
        break
      }
    }

    return ispc
  },
  /**
   * @description 兼容Chrome,包含chrome
   * @returns Boolean
   */
  isChrome: function () {
    return /chrome/.test(ua)
  },
  /**
   * @description 最低版本检测
   * @returns Boolean
   */
  chromeVersion: function () {
    let paltforms = ua.split(' ')
    let supportVerison = 74 // 支持的最低版本
    let isNotSuppoert = true

    if (ua.indexOf('chrome') < 0) {
      isNotSuppoert = false
    } else {
      for (let i = 0;i < paltforms.length;i++) {
        if (paltforms[i] && paltforms[i].indexOf('chrome') > -1) {
          let version = paltforms[i].split('/')[1]
          if (!version) {
            // 空版本，返回
            isNotSuppoert = false
            break
          } else {
            version = version.split('.')[0]
            if (isNaN(version)) {
              // 不是数字
              isNotSuppoert = false
              return
            }

            if (version < supportVerison) {
              // 低于版本
              isNotSuppoert = false
              return
            }
          }
        }
      }
    }

    return isNotSuppoert
  },
  /**
   * @description 是否是百度浏览器
   * @returns {Boolean}
   */
  isBaiduBroswer() {
    return /baidu/g.test(ua)
  },
  /**
   * @description UC浏览器
   * @returns {Boolean}
   */
  isUCBroswer() {
    return /ucbrowser/g.test(ua)
  },
  /**
   * @description QQ浏览器
   * @returns
   */
  isQQBroswer() {
    return /qqbrowser/g.test(ua)
  },
  /**
   * @description huawei浏览器
   */
  isHuaWeiBrowser() {
    return /huaweibrowser/g.test(ua)
  },
  /**
   * @description safari浏览器
   */
  isSafari() {
    return /safari/g.test(ua) && !/chrome/g.test(ua)
  },
  /**
   * @description 微信内置环境
   * @returns {Boolean}
   */
  isWeixin() {
    return /micromessenger/g.test(ua)
  },
  /**
   * @description 鸿蒙系统
   * @returns {Boolean}
   */
  isHarmonyOS() {
    return /harmonyos/g.test(ua)
  },
  /**
   * @description IOS 系统
   */
  isIOS() {
    return ua.indexOf('like mac os x') > -1
  },
  /**
   * @description IOS 10以上
   */
  iOSVersion() {
    let regStrIOSVersion = /os [\d._]*/gi
    let verinfo = ua.match(regStrIOSVersion)
    let ver = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
    return ver
  },
  /**
   * @description Android 6以上
   */
  androidVerison() {
    let regStrAndroidVersion = /android [\d._]*/gi
    let verinfo = ua.match(regStrAndroidVersion)
    let ver = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
    return ver
  },
  /**
   * @description 安卓系统
   */
  isAndroid() {
    return /android/g.test(ua)
  },
  /**
   * 是否是在小米手机打开
   */
  isXiaoMi() {
    return /mi/g.test(ua)
  },
  /**
   * 是否是百合部落APP内环境
   */
  isLILYTribeAPP() {
    return /lilytribe/g.test(ua)
  },
}
